<template>
  <div class="topbar-wrapper">
    <nav class="navbar navbar-expand navbar-light topbar mb-4 static-top shadow-sm">
      <!-- Background Animations -->
      <div class="bg-animations">
        <div class="bubble b1"></div>
        <div class="bubble b2"></div>
        <div class="bubble b3"></div>
        <div class="bubble b4"></div>
        <div class="bubble b5"></div>
      </div>

      <!-- Sidebar Toggle (Topbar) -->
      <button id="sidebarToggleTop" class="btn btn-link d-md-none rounded-circle mr-3 text-white"
        @click="$emit('toggle-sidebar')">
        <i class="fa fa-bars"></i>
      </button>

      <!-- Page Title -->
      <div class="d-none d-lg-flex align-items-center mr-auto position-relative">
        <h3 class="page-title mb-0" v-text="$route.name"></h3>
      </div>

      <!-- Topbar Navbar -->
      <ul class="navbar-nav ml-auto align-items-center position-relative">

        <!-- Optional: Add Notifications/Messages icons here if needed in future -->

        <div class="topbar-divider d-none d-sm-block"></div>

        <!-- Nav Item - User Information -->
        <li class="nav-item dropdown no-arrow">
          <a class="nav-link dropdown-toggle user-profile-link" href="#" id="userDropdown" role="button"
            data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <span class="mr-2 d-none d-lg-inline text-white small user-name">{{ DisplayName }}</span>
            <div class="img-profile-wrapper">
              <img class="img-profile rounded-circle" src="img/undraw_profile.svg" alt="User Profile" />
            </div>
          </a>
          <!-- Dropdown - User Information -->
          <div class="dropdown-menu dropdown-menu-right shadow animated--grow-in custom-dropdown"
            aria-labelledby="userDropdown">
            <a class="dropdown-item" href="#">
              <i class="fas fa-user fa-sm fa-fw mr-2 text-primary"></i>
              Profile
            </a>
            <a class="dropdown-item" href="#">
              <i class="fas fa-cogs fa-sm fa-fw mr-2 text-primary"></i>
              Settings
            </a>
            <a class="dropdown-item" href="#">
              <i class="fas fa-list fa-sm fa-fw mr-2 text-primary"></i>
              Activity Log
            </a>
            <div class="dropdown-divider"></div>
            <a class="dropdown-item logout-item" href="#" @click.prevent="LogoutUser">
              <i class="fas fa-sign-out-alt fa-sm fa-fw mr-2 text-danger"></i>
              Logout
            </a>
          </div>
        </li>
      </ul>
    </nav>
  </div>
</template>

<script>
import Common from "@/Common.vue";
export default {
  mixins: [Common],
  data() {
    return {
      ProfileImagePath: "",
      DisplayName: "",
    };
  },
  beforeMount() {
    var user = this.$session.get("user");
    console.log({ user });
    user = user == (null || undefined) ? {} : user;
    console.log({ user });

    var DisplayName = user.hasOwnProperty("DisplayName") ? user.DisplayName : "";
    console.log({ DisplayName });
    this.DisplayName = DisplayName;

  },
};
</script>

<style scoped>
.topbar-wrapper {
  width: 100%;
}

.topbar {
  background: linear-gradient(135deg, #0780f8 0%, #021a70 100%);
  height: 4.375rem;
  transition: all 0.3s ease;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  position: relative;
  /* overflow: hidden; Removed to allow dropdown to show */
}

/* Background Animations */
.bg-animations {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  /* Added here to clip bubbles */
  z-index: 0;
  pointer-events: none;
}

.bubble {
  position: absolute;
  bottom: -50px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 50%;
  animation: floatUp 15s infinite linear;
}

.b1 {
  width: 40px;
  height: 40px;
  left: 10%;
  animation-duration: 8s;
  animation-delay: 0s;
}

.b2 {
  width: 20px;
  height: 20px;
  left: 20%;
  animation-duration: 5s;
  animation-delay: 1s;
}

.b3 {
  width: 50px;
  height: 50px;
  left: 35%;
  animation-duration: 10s;
  animation-delay: 2s;
}

.b4 {
  width: 80px;
  height: 80px;
  left: 50%;
  animation-duration: 12s;
  animation-delay: 0s;
}

.b5 {
  width: 35px;
  height: 35px;
  left: 80%;
  animation-duration: 7s;
  animation-delay: 3s;
}

@keyframes floatUp {
  0% {
    transform: translateY(0) rotate(0deg);
    opacity: 0;
  }

  10% {
    opacity: 1;
  }

  90% {
    opacity: 1;
  }

  100% {
    transform: translateY(-800px) rotate(360deg);
    opacity: 0;
  }
}

.page-title {
  font-weight: 700;
  color: #fff;
  font-size: 1.5rem;
  letter-spacing: 0.5px;
  text-transform: capitalize;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  position: relative;
  z-index: 1;
}

.topbar-divider {
  width: 0;
  border-right: 1px solid rgba(255, 255, 255, 0.2);
  height: calc(4.375rem - 2rem);
  margin: auto 1rem;
  position: relative;
  z-index: 1;
}

/* User Profile Link */
.user-profile-link {
  display: flex;
  align-items: center;
  padding: 0.5rem 1rem;
  border-radius: 30px;
  transition: background 0.2s ease;
  position: relative;
  z-index: 1;
}

.user-profile-link:hover {
  background: rgba(255, 255, 255, 0.1);
  text-decoration: none;
}

.user-name {
  font-weight: 600;
  font-size: 0.9rem;
  color: rgba(255, 255, 255, 0.9) !important;
}

.img-profile-wrapper {
  position: relative;
  padding: 2px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  backdrop-filter: blur(5px);
}

.img-profile {
  height: 2.5rem;
  width: 2.5rem;
  border: 2px solid #fff;
  background-color: #fff;
}

/* Dropdown Customization */
.custom-dropdown {
  border: none;
  border-radius: 0.5rem;
  padding: 0.5rem 0;
}

.dropdown-item {
  padding: 0.75rem 1.5rem;
  font-weight: 500;
  color: #3a3b45;
  transition: all 0.2s;
}

.dropdown-item:hover {
  background-color: #f8f9fc;
  color: #4e73df;
  padding-left: 1.7rem;
  /* Subtle slide */
}

.dropdown-item i {
  width: 1.2rem;
  text-align: center;
  transition: transform 0.2s;
}

.dropdown-item:hover i {
  transform: scale(1.2);
}

.logout-item {
  color: #e74a3b;
}

.logout-item:hover {
  background-color: #ffeef0;
  color: #e74a3b;
}

/* Animations */
@keyframes growIn {
  0% {
    transform: scale(0.9);
    opacity: 0;
  }

  100% {
    transform: scale(1);
    opacity: 1;
  }
}

.animated--grow-in {
  animation-name: growIn;
  animation-duration: 0.2s;
  animation-timing-function: transform cubic-bezier(0.18, 1.25, 0.4, 1), opacity cubic-bezier(0, 1, 0.4, 1);
}
</style>